import React from 'react';

let data = {

  index: {

    intro: {
      cpeel: `Imagine glowing, clear and fresh skin in just Five Days. Now you can with the Herbal Aktiv CPeel™ – the unique skin resurfacing treatment based on natural botanicals.`,
      bpeel: `Herbal	Aktiv	Beauty	Peel	(BPEEL™)	is	a natural	peeling	procedure for	skin regeneration	based	on	a	mixture	of natural herbs.

It	provides	immediate glowing plumped	skin	with	no	down	time	or visible peeling.`,
      ppeel: `Whether	it’s	the	early	onset	of	wrinkles	and/or pigmentation,	or	the	pesky problem	of	breakouts and	skin	sensitivity	- Phyto	Treatment	Mini	Peel (PPEEL™)	is your	saviour.`
    },

    treatment: {

      body: `Imagine glowing, clear and fresh skin in just Five Days. Now you can with the Herbal Aktiv CPeel™ – the unique skin resurfacing treatment based on natural botanicals.
That’s right – NO:`,

      body2: `Just nature’s best working with your skin.

Skin resurfacing is a well-documented and accepted method for improving skin’s appearance and resolving difficult skin conditions. This treatment replaces dermabrasion, acid peels and heat.

Herbal Aktiv Peel uses a unique patented formula of dried, crushed herbs to slough away skin revealing plump new energised skin.

With over 50 years of success Herbal Aktiv Peel is the ideal natural solution to perfect glowing skin.`,

      bodyOriginal: `C stands for ‘corrective’. This is the gold standard of herbal peeling treatments. It carries the well-deserved tagline ‘New Skin in 5 Days’.

The compound of dried, crushed herbs is mixed with a herbal lotion, then massaged into the skin. Following the treatment the skin is slightly reddened and the herbal particles can be felt. These particles slowly release their actives – proteins, carbohydrates, vitamins, enzymes, phytohormones, mineral salts, tannins and trace elements – into the skin over the next two days. The top layer of skin dries out as new cells from underneath. On day four the skin starts to peel. This is followed by a visit to the beauty salon where any remaining old skin will be massaged off. A hydrating mask treatment finishes the protocol.

CPeel™ has shown outstanding results with high levels of safety over many years. For some results click here. For testimonials click here.`,

      points: [
        `Toxins`,
        `Acids`,
        `Silicone`,
        `Harsh chemicals`,
        `No synthetic peeling ingredients`
      ]

    },

    history: {

      body: `First trials with herbal peeling started in the late 1950’s in Germany. Initially the treatment was performed in dermatological hospitals and was focussed on the treatment of difficult acne cases. It was found that the treatment had beneficial effects on a number of skin concerns: premature aging, lines and wrinkles, pigmentation of the skin, scarring, milia and more.

The treatment proved to be very safe and was subsequently made available to the beauty industry. A number of different protocols have been developed.`,

    },

    homecare: {

      superLotion: {
        array: [
          "Soothes and protects the skin",
          "Relieves tension and provides hydration",
          "Reduces redness and irritation",
          "Anti-irritating, anti-inflammatory properties"
        ],
        body: "A soothing toner with herbal extracts that relaxes and refreshes the skin. Prevents skin irritation and helps return its moisture balance"
      },

      vitaminCream: {
        array: [
          "Calms and soothes",
          "Is moisture-binding, soothing and calming",
          "Improves skin‘s resistance",
          "Rehydrates and regenerates",
          "Works antiseptic, revitalizing and nurturing for eczema"
        ],
        body: "Specialty cream to help the skin build up and preserve its optimum moisture balance. Calms and restores skin‘s natural functions"
      },

      clearCream: {
        array: [
          "Shows antibacterial, anti-inflammatory and soothing properties",
          "Inhibits itching and irritation",
          "Normalizes sebaceous production",
          "Improves skin resistance",
          "Nourishes, cares for the skin and provides an even appearance"
        ],
        body: "Specialty care cream with Tea Tree Oil. Reduces impurities from spreading normalizes sebaceous production and mattifies.  Reduces redness and irritation, refines pores and hydrates skin."
      },

      bbCream: {
        array: [
          "Normalizes skin functions",
          "Neutralizes and repairs red, irritated and sensitized skin",
          "Reduces efflorescences and fosters healing process",
          "Works anti-inflammatory on impure skin and acne",
          "Cares for and calms couperosis und rosacea",
          "Covers and minimizes pores, uneven skin tone and scars",
          "Shields sun and environmental aggressors (all-weather)",
          "Shows light brightening properties"
        ],
        body: "Offers optimal coverage, care and protection. Especially designed for red, irritated, blemished and problem skin, which needs special care and attention. Balances skin and soothes irritation while offering a flawless finish."
      }

    },

    fiveDays: {

      oneBold: <b>Herbal Aktiv Peel®</b>,
      one: ` is applied at your accredited salon. Skin will appear flush`,
      two: `Use prescribed home care products diligently – skin looks normal`,
      three: `Continue to use home care products – first signs of peeling may appear`,
      four: `Noticeable peeling of skin. You may want to stay at home on this day. Continue to apply home care products and DO NOT be tempted to peel skin manually. Let it shed naturally`,
      five: `Return to clinic for post treatment and enjoy the reveal of your new skin`

    },

    todayTonight: {

      body: `Herbal Aktiv Peel® was featured on popular news show "Today Tonight" to much acclaim.`

    },

    ingredients: {
      spirulina: {
        name: "Spirulina",
        sciName: "spirulina maxima",
        image: require("../images/herbal-peel/ingredients/spirulina.jpg"),
        description: "A microscopic blue green algae in the shape of a spiral coil.",
        properties: `Antioxidant, anti-inflammatory and immune modulating properties. Contains high protein (up to 77%) and all the essential amino acids, including vitamins Bi, B2, B3, B9, C, D, A and E. Is rich in minerals potassium, calcium, chromium, copper, iron,magnesium, manganese, phosphorus, selenium, sodium and zinc.`
      },
      ginseng: {
        name: "Ginseng",
        sciName: "panax ginseng",
        image: require("../images/herbal-peel/ingredients/ginseng.jpg"),
        description: "A slow-growing perennial plant with fleshy roots.",
        properties: `Anti-carcinogenic and antioxidant action, increased blood flow, stimulates cell renewal and regeneration.`
      },
      fenugreek: {
        name: "Fenugreek",
        sciName: "trigonella foenum-graecum",
        image: require("../images/herbal-peel/ingredients/fenugreek.jpg"),
        description: "An annual herb that has white flowers and aromatic seeds.",
        properties: `Contains protein, vitamins C, E, niacin and potassium.

It also has phyto-estrongenic properties and is used as a herbal remedy for wrinkles, dryness, blackheads, rashes and pimples, eczema and burns.`
      },
      marshmallow: {
        name: "Marshmallow",
        sciName: "althaea officinalis",
        image: require("../images/herbal-peel/ingredients/marshmallow.jpg"),
        description: "A medicinal ornamental plant.",
        properties: `Renowned for its expectorant, diuretic, vulnerary and emollient properties. Used for ulcers, abscesses and boils.`
      },
      calendula: {
        name: "Calendula",
        sciName: "calendula officinalis",
        image: require("../images/herbal-peel/ingredients/calendula.jpg"),
        description: "An aromatic perennial plant for treating skin disorders and pain.",
        properties: `Provides the skin with antibacterial, anti-fungal and anti-inflammatory properties for the treatment of dermatitis, skin infections, cuts, burns and chafed skin. The petals and pollen contain triperpenoid esthers (anti-inflammatory) and carotenoid flavoxanthin and auroxanthin, which are potent anti-oxidants.`
      },
      chamomile: {
        name: "Chamomile",
        sciName: "matricaria recutita",
        image: require("../images/herbal-peel/ingredients/chamomile.jpg"),
        description: "An annual plant known as German Chamomile.",
        properties: `Anti-inflammatory properties and speeds healing. In vitro, chamomile helps to demonstrate moderate antimicrobial and antioxidant properties.`
      },
      pansy: {
        name: "Pansy",
        sciName: "viola tricolor hortensis",
        image: require("../images/herbal-peel/ingredients/pansy.jpg"),
        description: "Biennial hybrid plant used in herbal medicine.",
        properties: `Anti-inflammatory properties have been used in herbal medicine.

Applied externally it has been very successful in relieving scabs, itching and ulcers as well as eczema and has also been used traditionally for acne and any condition where inflammation is present.`
      },
      largeLeafLinden: {
        name: "Large Leaf Linden",
        sciName: "tilia platyphyllos",
        image: require("../images/herbal-peel/ingredients/large-leaf-linden.jpg"),
        description: "Linden comes from a deciduous tree native to much of Europe. Its flowers, leaves, wood and charcoal are used for medicinal purposes.",
        properties: `Active ingredient includes flavanoids and volatile oils that soothe and reduce inflammation.

The plant also contains tannin that can act as an astringent.`
      },
      lemonBalm: {
        name: "Lemon Balm",
        sciName: "melissa officinalis",
        image: require("../images/herbal-peel/ingredients/lemon-balm.jpg"),
        description: "A perennial herb in the mint family with a gentle lemon scent.",
        properties: `Renowned for its anti-bacterial and anti-viral properties.

It also contains terpenes that add to its calm ing and soothing effect.`
      },
      lungwort: {
        name: "Lungwort",
        sciName: "pulmonaria officinalis",
        image: require("../images/herbal-peel/ingredients/lungwort.jpg"),
        description: "An evergreen and flowering plant cultivated as a medical herb.",
        properties: `Traditionally used for wound therapy and as a diuretic, also for skin infections, inflammation and burns.

It is rich in flavonoids, glycosides, tannins and iridoids that all have strong antioxidant and anti-inflammatory properties.`
      },
      fieldHorsetail: {
        name: "Field Horsetail",
        sciName: "equisetum arvense",
        image: require("../images/herbal-peel/ingredients/field-horsetail.jpg"),
        description: "A bushy perennial with medicinal properties.",
        properties: `It has abrasive properties due to silica deposits in its stems. Rich in minerals potassium and calcium, cadmium, copper and zinc.

It is an excellent fungicide and has traditionally been used by herbalists to treat ulcers and wounds.`
      },
      sage: {
        name: "Sage",
        sciName: "salvia officinalis",
        image: require("../images/herbal-peel/ingredients/sage.jpg"),
        description: "Another member of the mint family with a long history of medicinal use.",
        properties: `Sage has many healing properties including anti-inflammatory, oestrogenic, and antioxidant.

It is known to support increased capillary strength and resistance.`
      },
      witchHazel: {
        name: "Witch Hazel",
        sciName: "hamamelis virginiana",
        image: require("../images/herbal-peel/ingredients/witch-hazel.jpg"),
        description: "A deciduous large shrub from which astringent witch hazel is extracted for medical use.",
        properties: `Beneficial in healing inflammation, itching, bruises and scratches in conditions such as eczema and bedsores. Due to the presence of tannins it has the ability to counteract inflammation, skin injuries and varicose veins.`
      },
      ribwortPlantain: {
        name: "Ribwort Plantain",
        sciName: "plantago lanceolata",
        image: require("../images/herbal-peel/ingredients/ribwort-plantain.jpg"),
        description: "A small inconspicuous plant that has round delicate leaves similar to mint.",
        properties: `Action is astringent and diuretic, used topically as an emollient that can help burns, insect stings, sunburn and skin disorders.

It also contains phenols that contribute to its healing properties.`
      }
    }
  },

  bbcream: {

    history: {

      bodyFirstLetter: `T`,

      bbBody: `he cream that started it all! With over 50 years of rich history and continued research and innovation this is the only BB cream you need and want.

Ideal for blemished, sensitised skin, or any skin type that requires extra care. The formulation offers optimal coverage, care and protection.`,

      points: [
        `Evens skin tone`,
        `Soothes irritation`,
        `Provides a flawless finish`,
        `Balances reddened skin`,
        `Colours that match skin perfectly and seamlessly in shades of:`
      ],
      shades: [
        `Nude Tone`,
        `Medium Tone`,
        `Dark Tone`
      ]
    },

    bbRange: {
      heading: `A BB Cream for every skin`,
    },

    whatIsBB: {
      bodyEdit: `BB creams (Beauty balms or Blemish balms) were first created to soothe and conceal skin undergoing treatment. The formula proved to be so popular that it soon became the must-have product for its versatility and results.`,
      body: `BB creams (Beauty balms or Blemish balms) were first created in Germany to soothe and conceal skin while undergoing treatment for acne and/or laser treatment. The formula proved to be so popular that it soon became the must-have product for its versatility, seamless application and results.`
    },

    porcelainIntro: {
      heading: `White GOLD for your skin`
    },

    whatIsPG: {

      body: `VC-IP (an innovative vitamin c derivative) in combination with an active brightening
      powder, instantly corrects the appearance of localized skin discoloration and imperfections,
      enlarged pores and provides high opacity UVA + UVB protection. with regular use, this active
      complex with select revitalizing vitamins and powerful anti-ageing properties, reveals a more even,
      brighter skin tone. Locks in moisture and delivers the ultimate porcelain finish with a youthful
      radiant glow.`

    },

    porcelain: {
      header: `Give your skin the glow it deserves`,
      subheading: `A tiny dab is all that is needed to give your skin the glow it deserves. Alex Cosmetics Porcelain Glow Balm is like no other primer`,
      body: `The Porcelain Glow Balm revitalises, regenerates, brightens, mattifies and hydrates your skin and allows make up to last, feel and look better. With continued use the active complex will help brighten your skin to reveal an evened skin tone.

This all-in-one concealer, primer and corrector is a definite must-have and without doubt “white gold for the skin”.`,

      dotPoints: [
        `VC-IP (a Vitamin C derivative for anti-aging and free radical protection)`,
        `Active brightening powder`,
        `Revitalizing vitamins`,
        `Powerful anti-ageing properties`,
        `UVA and UVB protection`
      ]
    }

  },

  phyto: {

    poster: {
      points: [
        `No Downtime`,
        `No Visible Peeling`,
        `Comfortable`,
        `5 Treatment Options`,
        `Larger Area`,
        `Suitable for All Skins`
      ]
    },

    intro: `Herbal Aktiv Beauty Peel (BPEEL™)	is	a	natural	peeling	procedure for	skin regeneration	based	on	a	mixture	of	natural herbs.

It provides	immediate glowing	plumped	skin	with	no	down	time	or	visible peeling.

Its	unique composition is completely free	from chemicals,	synthetic	binders	and	abrasives	and	therefore	there	are	no	toxic	side	effects.

The	special	blend	contains	proteins,	carbohydrates,	vitamins,	enzymes, phytohormones,	mineral	salts,	tannins	and	trace	elements.

BPeel™	treatment	is	an easily	performed,	regenerative	treatment	that	is	a	gentle yet	highly	effective	facial	procedure.

This	one-day procedure	is	a	natural	kick-starter	to	great	looking	skin`,

    uses: {

      body: ` One BPeel™ will make a visible difference, a course of six treatments over six weeks is recommended for long-term results. Herbal Aktiv Peel BPeel™ is not a replacement to the CPeel™ treatment but a complimentary procedure to help maintain and enhance healthy skin.`,

      addenum: `You can further customise/target your BPeel™ treatment accordingly.`,

      treatmentPoints: [
        "Helps to activate skin’s metabolism",
        "Helps improve skin’s microcirculation",
        "Activates skin’s repair mechanisms through targeted, controlled irritation",
        "Skin is optimally prepared and receptive for subsequent products and treatments",
        "Improves skin complexion without visible signs of peeling"
      ],

      usesPoints: [
        "A preventative anti-aging treatment (also for hands, neck and décolletage)",
        "A fast and extremely effective regenerative treatment",
        "An ideal intense quick pick-me-up treatment to keep skin looking flawless."
      ]

    },

    comparison: {

      heading: `BPeel CPeel comparison`,

      treatmentGoals: [
        "Increasing Blood Circulation",
        "Detoxifying the Skin",
        "Regulating Skin Metabolic Processes",
        "Activating Skin Regeneration Processes",
        "Germinating New Cells and Producing Collagen Fibers"
      ],

      phytoPoints: [
        `No signs of peeling`,
        `Comfortable`,
        `No Downtime`,
        `5 Treatment Options`,
        `Larger Area`,
        `Suitable For All Skins`
      ],

      HAPPoints: [
        `Extensive peeling of the upper epidermis`,
        `Herbal Resurfacing`,
        `Minimal Downtime`,
        `New Skin in 5 Days`,
        `Non Invasive`,
        `Proven Results`
      ]
    }
  },

  ppeel: {
    intro: {
      body: `Whether	it’s	the	early	onset	of	wrinkles	and/or pigmentation,	or	the	pesky problem	of	breakouts	and	skin	sensitivity	- Phyto	Treatment	Mini	Peel (PPeel™)	is your	saviour.

The	PPeel™ is	a gentle	treatment	with	natural	herbs	and	enzymes	similar	to	a	strong	micro-dermabrasion	procedure.	There	is	one	key	difference:	no	harmful	micro-injuries	are	inflicted	on	the	skin’s	delicate	acid	mantle that	means	no	redness,	irritation	or	sensitivity.

In	fact,	the	PPeel™ is	so	gentle	that	it’s	safe	for	pregnant	women	or	those	prone	to	sensitive	skin	and	can easily be	repeated	every	fortnight.	It’s	the	ultimate	quickfix skin	treatment	to	achieve	a	smoother,	plumper	complexion.

There	are	four	targeted	treatments	to	choose	from.`
    },

    treatments: {
      energise: `A power-packed	facial	treatment	designed	to	stimulate	microcirculation	and	revitalise	sluggish	skin	showing	signs	of	premature	aging.`,
      calm: `Ideal	for	skin	displaying	signs	of	redness,	couperose (a	permanently	pink complexion),	inflammation	or	sensitivity.	It	helps	to	gently	stimulate	and	rebalance	sensitised	skins	without	aggravation	or	irritation.`,
      clear: `A	detoxing	treatment	suitable	for	impure,	congested	and	acneic skins	suffering	from	hyperkeratinisation.	It	aids	in	the	decongestion	of	blocked	pores	and	helps	to	reduce	excess	oil	flow.`,
      restore1: `A	revitalising,	firming	treatment	suitable	for	mature,	sun	damaged	and	prematurely	aged	skins.
      *Phyto	Restore	is	a	stand alone	treatment	and	is`,
      restoreBold: ` not	a	substitute`,
      restore2: ` for	the	Herbal Aktiv C Peel™.`
    }
  },

  contact: {

    body: `The Herbal Aktiv Peel® is performed by specially trained aestheticians in a professional environment. If required treatments can be repeated in 4-weekly intervals. Your aesthetician will keep a photographic record of your progress with this outstanding skin resurfacing treatment. To find your nearest qualified aesthetician please enquire using the form below. Alternatively please call our office on 1300 301 007.`,

    number: `1300 301 007`

  },

  gallery: [
    {
      issue: 'Acne',
      numTreatments: 3,
      beforeImage: {
        url: require('../images/gallery/acne/acne-1a.jpg')
      },
      afterImage: {
        url: require('../images/gallery/acne/acne-1b.jpg')
      }
    },
    {
      issue: 'Acne/Ingrown Hair',
      numTreatments: "One",
      beforeImage: {
        url: require('../images/gallery/acne/acne-ingrown-hair-1a.jpg')
      },
      afterImage: {
        url: require('../images/gallery/acne/acne-ingrown-hair-1b.jpg')
      }
    },
    {
      issue: 'Crows Feet',
      numTreatments: 'x',
      beforeImage: {
        url: require('../images/gallery/crows-feet/crows-feet-1a.jpg')
      },
      afterImage: {
        url: require('../images/gallery/crows-feet/crows-feet-1b.jpg')
      }
    },
    {
      issue: 'Crows Feet',
      numTreatments: 'x',
      beforeImage: {
        url: require('../images/gallery/crows-feet/crows-feet-2a.jpg')
      },
      afterImage: {
        url: require('../images/gallery/crows-feet/crows-feet-2b.jpg')
      }
    },
    {
      issue: 'Freckles',
      numTreatments: 'x',
      beforeImage: {
        url: require('../images/gallery/freckles/freckles-1a.jpg')
      },
      afterImage: {
        url: require('../images/gallery/freckles/freckles-1b.jpg')
      }
    },
    {
      issue: 'Loose Skin',
      numTreatments: 'x',
      beforeImage: {
        url: require('../images/gallery/loose-skin/loose-skin-1a.jpg')
      },
      afterImage: {
        url: require('../images/gallery/loose-skin/loose-skin-1b.jpg')
      }
    },
    {
      issue: 'Pigmentation',
      numTreatments: 'x',
      beforeImage: {
        url: require('../images/gallery/pigmentation/pigmentation-2a.jpg')
      },
      afterImage: {
        url: require('../images/gallery/pigmentation/pigmentation-2b.jpg')
      }
    },
    {
      issue: 'Redness',
      numTreatments: 'x',
      beforeImage: {
        url: require('../images/gallery/redness/redness-1a.jpg')
      },
      afterImage: {
        url: require('../images/gallery/redness/redness-1b.jpg')
      }
    },
    {
      issue: 'Scarring',
      numTreatments: 'x',
      beforeImage: {
        url: require('../images/gallery/scarring/scarring-1a.jpg')
      },
      afterImage: {
        url: require('../images/gallery/scarring/scarring-1b.jpg')
      }
    },
    {
      issue: 'Sun Damage',
      numTreatments: 'x',
      beforeImage: {
        url: require('../images/gallery/sundamage/sundamage-1a.jpg')
      },
      afterImage: {
        url: require('../images/gallery/sundamage/sundamage-1b.jpg')
      }
    },
    {
      issue: 'Wrinkles',
      numTreatments: 'x',
      beforeImage: {
        url: require('../images/gallery/wrinkles/wrinkles-1a.jpg')
      },
      afterImage: {
        url: require('../images/gallery/wrinkles/wrinkles-1b.jpg')
      }
    }
  ],

  testimonials: [
    {
      body: `My	self-esteem	is	much	higher	as	I	feel	as	if	I	have	been	able	to	take	control.	My skin feels	great	now	and	I	think	it	is	well	worth	the	money	as	it	includes	the	 creams,	which	last	me	a	good	two	months	afterwards. Go	for	it!`,
      name: "Vanessa"
    },
    {
      body: `I’ve	hunted	down	the	most	incredible	skin	rejuvenation	I’ve	seen	in	my	many	years	in this	industry.	It’s	not	new	but	hard	to	find.	It’s	not	chemicals	– all	natural.	It	is	AMAZING.`,
      name: "Yvonne	Buckley,	Nouvelle	Skin	&	Beauty,	Carindale"
    },
    {
      body: `All	my	life,	I’ve	NEVER	had	perfect	skin… I	was	desperately	searching	for	a	cure	for	my severe	adult	acne	for	around	a	year	and	a	half…	I	was	put	on Roaccutane…I	was	given	the	choice	of	either	continuing	with	the	harmful	medications	or	to	give	the	Herbal	Aktiv	Peel	a	go… I	would	highly	recommend anyone	to	try	Herbal	Aktiv	Peel…it is	very obvious	that	it	works!	I	am	an	unmistakable	living	proof	of	that.	I	feel	that	my	money	is definitely	well spent.`,
      name: `Florence	Kok`
    },
    {
      body: `I recently finished my Herbal Aktiv Peel® and just thought I would let you know how pleased I was with the result. My skin looks a lot clearer, the fine lines around my mouth and eye area have diminished considerably, and it has also helped me with a couple of scars on my forehead which happened as a result of an illness I contracted last year.`,
      name: `Linda`
    },
    {
      body: `After having my first Herbal Aktiv Peel® treatment I was very pleased with the results because for the first time ever something has actually made a difference to the way my skin looks. I notice that my complexion looks brighter, refreshed and my pigmentation/scars appear to be significantly lighter.`,
      name: `Jenny`
    },
    {
      body: `I'm a dentist, and as such I work with people every day. I used to be ashamed of my acne prone and scarred skin; hiding behind my face mask when talking to patients for fear of them seeing my skin up close. But now thanks to the Herbal Aktiv Peel® treatment, my way of life has changed completely. I'm a much happier, confident person now - and people compliment my skin!`,
      name: "Doreen"
    }
  ],

  news: [
    {
      heading: 'What is the difference between acid peels and the Herbal Aktiv Peel?',
      subheading: 'We are often asked whether the Herbal Aktiv Peel contains acids. The answer is no but many are sceptical. They cannot believe that herbs could cause a significant epidermal peel...',
      image: require('../images/news/hap-capabilities.jpg'),
      body:
      <div>
        <p>We are often asked whether the Herbal Aktiv Peel contains acids. The answer is no but many are sceptical. They cannot believe that herbs could cause a significant epidermal peel such as illustrated in the attached photograph. <br/> Here are a few clues that confirm the ‘no acid’ theory:</p>
        <ul className="herbs animated">
          <li>When working with acid peels you need to be very careful that the peeling agent doesn’t get into the eyes or into the mouth. There is no such requirement for the Herbal Aktiv Peel: if herbs get into the eyes they can simply (and calmly) be washed out with water. In the mouth they will feel gritty; they can be swallowed or spat out.</li>
          <li>With acid peels caution is required to ensure the substance doesn’t stay on the skin too long as this would cause damage or complications. It doesn’t matter how long the Herbal Aktiv Peel stays in contact with the skin; there is no danger of skin damage.</li>
          <li>The Herbal Aktiv Peel is massaged into the skin with bare hands. No gloves are required. In fact, several such treatments can be performed by the aesthetician in one day. There is no damage to the hands and, as there are no pores on the palms of the hands, the skin doesn’t peel.</li>
        </ul>
        <div className="conversation">
          <p>Recently we discussed the attached photograph with an expert on acid peels. Here is the discussion that took place:</p>
          <p><b>OmniDerm:</b> Seeing the peeling on our photograph, what kind of acid peel would achieve a similar result in peeling of the skin?</p>
          <p><b>Expert:</b> To get these results you need a very potent acid peel; most likely a Trichloric Acid (TCA) peel, at a high percentage.</p>
          <p><b>OmniDerm:</b> This photograph was taken five days after the initial Herbal Aktiv Peel treatment. The new skin looks calm and healthy. Would skin look like this, five days, after a strong TCA peel?</p>
          <p><b>Expert:</b> No, definitely not. The skin would be red raw and weeping. It would be impossible to wear clothing. The skin would need to be protected against infection.</p>
        </div>
        <p>This illustrates the main advantage of the Herbal Aktiv Peel and explains the reason why it is a safer skin resurfacing treatment compared to other peels.</p>
        <p>With Herbal Aktiv Peel the skin’s barrier is never broken. The old skin stays intact during the initial treatment. New skin forms underneath, and when this new skin is ready to face the light of day the old skin will spontaneously peel off.</p>
        <p>This process happens over five short days: on day two the skin starts to feel tight, on day 3 it is a dead layer and on day four it peels off. The actual peeling process takes about 24 hours and looks no different than a peeling following sunburn. Special home care products camouflage the peeling. During the Post-Treatment in the salon any remaining dead skin is massaged off. The client leaves with radiant, healthy looking skin.</p>
        <p>Today’s consumer expects every skin care clinic to offer a combination of corrective treatments and specialized maintenance care for best long term results. The Herbal Aktiv Peel is a corrective treatment for skin clinics wishing to offer superior results with high levels of safety.</p>
        <p>Photographs from a number of practitioners around Australia illustrate the effect of this peel on a number of difficult skin conditions, including acne and impure skin, prematurely aged skin, pigmentation, freckles and sun spots, scarring, milia and stretch marks.</p>
      </div>
    },
    {
      heading: 'Anti-ageing – a different perspective',
      subheading: 'Many different ‘corrective’ measures have been developed over the years. Ultimately, the method remains the same - outer layers of the skin are damaged or injured in some way to generate re-growth of new skin layers...',
      image: require('../images/news/girl-dots.jpg'),
      body:
      <div>
        <p>An effective anti-ageing skin care strategy rests on two complementary modalities:</p>
        <ul className="herbs animated">
          <li>Corrective treatments are designed to achieve dramatic changes in the appearance of the skin in a short time frame</li>
          <li>Maintenance care quickly allows the skin to regain its natural healthy appearance and assists in prevention, helping delay the signs of ageing</li>
        </ul>
        <p>Many different ‘corrective’ measures have been developed over the years. Ultimately, the method remains the same - outer layers of the skin are damaged or injured in some way to generate re-growth of new skin layers.</p>
        <p>This approach in the short run will normally lead to an improvement in the appearance of the skin. Mediums used are heat (laser and intense pulsed light), a variety of chemical peels (deep, medium and superficial) or mechanical (dermabrasion, microdermabrasion, skin needling).</p>
        <p>Corrective treatments carry some measure of risk. Side effects, though infrequent, can be severe and lasting. Destruction of the pilo-sebaceous unit will result in healing by scar tissue.</p>
        <p>Following deep chemical peels the skin can develop an unnatural, plastic-like appearance. As a result, laser and deep peels have been losing popularity in some circles.</p>
        <p>Herbal Peeling is an alternative skin resurfacing treatment that is not well understood. Thousands of applications over 50 years have resulted in an enviable record of effectiveness and safety.</p>
      </div>
    },
    {
      heading: 'Herbal Aktiv Peel – the difference',
      subheading: 'Unlike traditional skin resurfacing methodologies, herbal peeling does not just rely on the skin’s natural healing response for a beneficial outcome. Active substances contained in the plants are made available to the skin in combinations and dosages that cannot be matched in products sourced from a laboratory. So what are some of these plants?',
      image: require('../images/herbal-peel/green-powder.jpg'),
      body:
      <div>
        <p>Since early civilisation humans have kept records of which plants have beneficial value, which may be useful as foods and which should be avoided. This information has been recorded in ancient herbal manuscripts and passed by word of mouth from generation to generation. Modern scientific tests have proven many of the beneficial properties ascribed to various plants. Research is continuing.</p>
        <p>Unlike traditional skin resurfacing methodologies, herbal peeling does not just rely on the skin’s natural healing response for a beneficial outcome. Active substances contained in the plants are made available to the skin in combinations and dosages that cannot be matched in products sourced from a laboratory. So what are some of these plants?</p>
        <div className="ingredients">
          <div>
            <img className="thumbnail" src={ require("../images/herbal-peel/ingredients/field-horsetail.jpg") } />
            <p><b>Horsetail (equisetum arvense)</b> contains the highest percentage known of silicic acid of any plant. This compound is an important component found in numerous tissues, including our connective tissue, collagen and elastin. Clinical tests conducted in Unna, Germany, have shown that the application of horsetail results in a firming of the skin, with increased elasticity.</p>
          </div>
          <div>
            <img className="thumbnail" src={ require("../images/herbal-peel/ingredients/calendula.jpg") } />
            <p><b>Marigold (calendula officinalis)</b> was considered so important that the early settlers took the seed to the Americas. Its topical healing activity has been demonstrated in clinical trials with burns, scalds and wounds. It has been found to reduce inflammatory reaction, is soothing to the skin and accelerates healing.</p>
          </div>
          <div>
            <img className="thumbnail" src={ require("../images/herbal-peel/ingredients/chamomile.jpg") } />
            <p><b>German chamomile (chamomilla recutita)</b> is today’s most explored medicinal plant. Its primary active component is α-bisabolol. It has proven anti-inflammatory and antimicrobial effects. The action of German chamomile is invaluable in cases of irritated, reddened and sensitive skin.</p>
          </div>
          <div>
            <img className="thumbnail" src={ require("../images/herbal-peel/ingredients/pansy.jpg") } />
            <p><b>Pansy (viola tricoloris)</b> is named in ancient texts as ‘the herb for girls with blemished skin’. It contains a variety of active substances that seem to have a positive effect in cases of impure and acneic skins.</p>
          </div>
          <div>
            <img className="thumbnail" src={ require("../images/herbal-peel/ingredients/ribwort-plantain.jpg") } />
            <p><b>Ribwort (plantago lanceolata)</b> was known as the ‘First Aid Plant’. It is used for external treatment of wounds and to stop bleeding. The plant has the ability to destroy a wide range of microorganisms and stimulates epithelialisation, the formation of new skin cells.</p>
          </div>
        </div>
        <p>These brief descriptions don’t do justice to the richness in content (vitamins, minerals, trace elements) nor actions (antiseptic, astringent, demulcent, styptic, cytophylactic) of the plants that make up the compound used in herbal peeling.</p>
        <p>From time to time we read about the importance of minerals and trace elements such as zinc, magnesium, copper, selenium, silicium, iron, phosphorus and more. Yet no man made formulation comes close to supplying a complete, well-rounded and synergistically active combination of these vital ingredients, as do these herbs.</p>
        <p>Once massaged into the skin, they slowly release their bioactive ingredients over two to three days. Doses are minute (we talk ‘millionths of a gram’) yet compared to regular delivery systems they are massive. They reinvigorate the skin in a way that differs fundamentally from the methodology of traditional skin resurfacing, i.e. the destruction of outer skin layers followed by healing.</p>
        <p>By its very nature a corrective procedure involves stress, irritation and inflammation of the skin. Inflammation has been named as a core cause of all skin conditions and should be kept to a minimum. It is one of the main reasons why daily application of products containing aggressive peeling agents is losing support with a growing number of experts.</p>
        <p>Inflammation is related to many processes in the skin. Following excessive exposure to the sun it can be observed as erythema. The healing process that follows a corrective procedure is accompanied by inflammation, as is a state of excessive dehydration of the skin.</p>
        <p>Inflammation as part of a healing process is to be welcomed; chronic or long-term inflammation must be avoided because it destroys collagen and elastic fibres and contributes to ageing.</p>
        <p>During the re-epithelialisation phase of a skin resurfacing procedure the barrier function of the skin is impaired, leading to excessive transepidermal water loss (TEWL).</p>
        <p>The skin reacts to this perceived external threat with an inflammatory response, hypersensitivity and oedema (fluid retention). At this stage it is vital to replenish the lipids in the stratum corneum to rapidly rebuild the skin’s protective barrier function, leading to better hydration, a significant reduction in erythema and faster reversal of the inflammation process. A well-formulated moisturiser will encourage re-epilialisation, decrease skin sensitivity and lessen the chance of scarring.</p>
        <p>Extensive research has been directed to the hydration properties of different emulsion types. It has been found that light water-in-oil (W/O) preparations are significantly more effective at protecting the skin against loss of moisture. They are the preferred choice following procedures that may lead to a temporary weakening of the stratum corneum barrier.</p>
        <p>Re-epithelialisation and rapid recovery of the skin can be supported with the inclusion of actives. These ingredients are carefully selected to create an environment that is optimal for cellular repair and the re-establishment of the epidermal barrier.</p>
        <p>Recent research has focused on peptides for their ability to support and speed the healing process. Vitamins, anti-oxidants and skin-identical substances such as natural moisturizing factors contribute greatly to a successful outcome. W/O emulsions have been proven to deliver significantly higher levels of bioactive ingredients compared to oil-in-water (O/W) emulsions.</p>
        <p>This may in part be due to their inherently better hydration properties: it has been claimed that well hydrated skin will absorb up to ten times the quantity of an active ingredient compared to dehydrated skin. As an added benefit W/O formulations typically contain lower and less sensitizing levels of potential irritants, such as preservatives and emulsifiers.</p>
        <p>Traditionally, skin care products containing acids, high levels of vitamin C or vitamin A have been used for maintenance of the skin. These are now increasingly seen as contributing to inflammation in the skin. Symptoms are redness, flaking and dehydration of the skin, or as one therapist put it: ‘The skin looks to be struggling.’ Periods of inflammation, such as experienced during a corrective procedure, should be kept as brief as possible. Long-term skin maintenance should be designed to reproduce the conditions found on young, healthy skin.</p>
        <p>These biomimetic skin care creams are gentle, working with the skin rather than breaking it down, leading to a significant and speedy reduction in levels of inflammation.</p>
        <p><b>Conclusion</b> <br/> The combination of herbal peeling with skin care based on biomimetic principles enables the skin professional to deliver a well-balanced skin care program:</p>
        <ul className="herbs animated">
          <li>The corrective stage combines high effectiveness with low risk.</li>
          <li>The inflammatory cycle of the corrective treatment is kept brief. New skin is apparent after five days.</li>
          <li>This is followed with calming, supporting and balancing daily care.</li>
          <li>Excellent results have been seen with skin problems like acne, scarring, sun damage, pigmentation and wrinkles.</li>
          <li>Anti-ageing – the appearance of prematurely aged and sun-damaged skin is improved.</li>
          <li>Preventive – the appearance of signs of ageing is delayed.</li>
        </ul>
        <p>The results are an optimal balance, leading to a fresher, younger and healthier appearance of the skin.</p>
      </div>
    },
    {
      heading: 'FEATURED IN - Harpers Bazaar Magazine, Spring 2015',
      subheading: '',
      image: require('../images/news/harpers-bazaar/harpers-bazaar-bride-2015-1.jpg'),
      body:
      <div>
        <img src={ require('../images/news/harpers-bazaar/harpers-bazaar-bride-2015-2.jpg') } />
        <img src={ require('../images/news/harpers-bazaar/harpers-bazaar-bride-2015-3.jpg') } />
      </div>
    },
    {
      heading: 'FEATURED IN - Wellbeing Magainze, Summer 2013',
      subheading: '',
      image: require('../images/news/wellbeing/wellbeing-cover-summer-2013-1.jpg'),
      body:
      <div>
        <img src={ require('../images/news/wellbeing/wellbeing-cover-summer-2013-2.jpg') } />
      </div>
    },
    {
      heading: 'FEATURED IN - Signature Magazine, Winter 2012',
      subheading: '',
      image: require('../images/news/signature/signature-autumn-2012-page-001.jpg'),
      body:
      <div>
        <img src={ require('../images/news/signature/signature-autumn-2012-page-002.jpg') } />
        <img src={ require('../images/news/signature/signature-autumn-2012-page-003.jpg') } />
      </div>
    },
    {
      heading: 'FEATURED IN - Jetstar Magazine',
      subheading: '',
      image: require('../images/news/jetstar/jetstar-november-2015-cover.jpg'),
      body:
      <div>
        <img src={ require('../images/news/jetstar/jetstar-november-2015-page-001.jpg') } />
        <img src={ require('../images/news/jetstar/jetstar-november-2015-page-002.jpg') } />
      </div>
    }
  ],

  about: {
    body1: `Omniderm was formed in 1996 to chart a course through the sea of promising but at times overwhelming skin care. The company set out to source the best results-driven and science backed skin care from around the world. Being extremely selective all brands under the Omniderm umbrella strive to be kind to nature, backed by science and satisfaction driven.`,
    body2: `After twenty years the company thrives on success stories and good skin health making sure customer service is at the forefront of the business.`,
    body3: `OmniDerm today is considered one of the main suppliers of professional skin care to the Australian market. Its brands, products, training and support have resulted in successful partnerships with a large number of skin care clinics, medi-spas and medical cosmetic clinics in every state of Australia.`,

    contact: {
      address: `1-7 Wilson Ave, Brunswick VIC 3056`,
      phone: `(03) 9645 0200`,
      fax: `(03) 9699 9593`
    }
  }

}

export default data;



/** WEBPACK FOOTER **
 ** ./src/core/data.js
 **/